export const CommonEnvironment = {
    endPoints: {
        authorize: 'authorize',
        postForResource: 'consentRequests',
        getFkn: 'consentRequests',
        getConsentObject: 'consentRequests',
        postConsent: 'consents',
        getPermissionConsent: 'consents',
        cancelConsent: 'consentRequests',
        postConsentRevoke: 'consents',
        internalUserAuth: 'authenticate'
    }
};
